import styled, { css } from 'styled-components'

type StyledAverageProps = {
  marginLeft: number
}

export const Average = styled.div<StyledAverageProps>`
  margin-top: -35px;
  ${({ marginLeft }) => css`
    margin-left: ${marginLeft}px;
  `}

  display: flex;
  align-items: baseline;
  height: 25px;
  justify-content: center;
  background-color: #e1e8fe;
  border-radius: 5px;
`

const textStyle = css`
  font-size: 12px;
  line-height: 25px;
  color: ${({ theme }) => theme.palette.black[50]};
`

export const Price = styled.span`
  ${textStyle};
  font-weight: 700;
`

type StyledDescriptionProps = {
  hiddenOnMobile: boolean
}

export const Description = styled.span<StyledDescriptionProps>`
  ${textStyle};
  font-weight: 400;

  ${({ hiddenOnMobile }) =>
    hiddenOnMobile
      ? css`
          @media (max-width: 767px) {
            display: none;
          }
        `
      : ''}
`
